import React from 'react';
import { TableCell, Box, Button, CircularProgress } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { BUTTON_SIZES, TABLE_STYLES } from './constants';
import { 
  isValidateDisabled, 
  isProcessDisabled, 
  getValidateTooltip, 
  getProcessTooltip 
} from './helpers';

const ActionButtons = ({ 
  entry, 
  validatingId, 
  processingId, 
  onValidate, 
  onProcess 
}) => (
  <TableCell
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: TABLE_STYLES.ACTIONS_CELL.minHeight,
      py: TABLE_STYLES.ACTIONS_CELL.padding,
    }}
  >
    <Box sx={{ 
      display: "flex", 
      flexDirection: "column",
      gap: 1, 
      alignItems: "center" 
    }}>
      {/* Validate Button */}
      <Button
        variant="contained"
        size="small"
        disabled={isValidateDisabled(entry.validationStatus, entry?.status, validatingId, entry._id)}
        onClick={() => onValidate(entry._id)}
        sx={BUTTON_SIZES.ACTION_BUTTON}
        title={getValidateTooltip(entry.validationStatus)}
      >
        {validatingId === entry._id ? (
          <CircularProgress size={20} />
        ) : (
          "Validate"
        )}
      </Button>

      {/* Process Button */}
      <Button
        variant="contained"
        color="success"
        size="small"
        disabled={isProcessDisabled(entry.validationStatus, entry?.status, processingId, entry._id)}
        onClick={() => onProcess(entry._id)}
        startIcon={
          processingId !== entry._id ? <PlayArrowIcon /> : null
        }
        sx={BUTTON_SIZES.ACTION_BUTTON}
        title={getProcessTooltip(entry.validationStatus, entry?.status)}
      >
        {processingId === entry._id ? (
          <CircularProgress size={20} />
        ) : (
          "Process"
        )}
      </Button>
    </Box>
  </TableCell>
);

export default ActionButtons;
